import React from 'react';
import PropTypes from 'prop-types';
import ChosenSelect from './ChosenSelect';

const ConsistFilter = ({ options, value, onChange }) => (
  <div className="consistSelection">
    <div className="chartControlTitle" data-testid="analysis-filters-panel-consist-label">Consist</div>
    <div className="input-group consistSelectorGroup">
      <i className="fas fa-search input-group-addon" />
      <ChosenSelect
        options={options}
        value={value?.value ?? ''}
        className="consistSelect"
        onChange={selectedValue => onChange(options.find(option => String(option.value) === String(selectedValue)) || null)}
        testId="analysis-filters-panel-consist-select"
      />
      <span className="input-group-addon" title="Clear selection">
        <button type="button" className="analysis-filter-clear" aria-label="Clear consist selection"
          onClick={() => onChange(null)} data-testid="analysis-filters-panel-consist-clear">
          <i className="fas fa-times" aria-hidden="true" />
        </button>
      </span>
    </div>
  </div>
);

ConsistFilter.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default ConsistFilter;